export const supplierDomains = {
  production: 'https://supplier360.cialdnb.com',
  staging: 'http://staging.supplier360.cialdnb.com',
  development: 'http://localhost:3000'
};
